import AddEditSection from "../../components/AddEditSection";
import Breadcrumb from "../../parts/Breadcrumb";
import React, { useEffect, useState } from "react";
import labels from "../../constants/Role";
import configuration from "../../config";
import { toast } from "react-toastify";
import { getAccessRights } from "../../utils/common";
import Loader from "../../components/Loader/Loader";

// For Add Role
function Add({ history }) {
  const statusOpt = [
    { id: 1, title: "Active", value: "active" },
    { id: 2, title: "Inactive", value: "inactive" },
    { id: 3, title: "Archive", value: "archive" },
  ];
  const fieldArr = [
    { id: 0, title: "Title", name: "title", type: "TextInput" },
    {
      id: 1,
      title: "Status",
      name: "status",
      type: "Dropdown",
      options: statusOpt,
    },
    { id: 2, title: "Description", name: "description", type: "TextArea" },
  ];
  const [fields, setFields] = useState({});
  const [isLoader, setIsLoader] = useState(false);
  const [errors, setErrors] = useState({
    title: "",
    description: "",
    status: "",
  });
  useEffect(() => {
    getAccessRights().then((rights) => {
      const rightsData = rights?.find((ac) => ac.code === "ROLE");
      if (rightsData?.add === false) {
        history.push("/dashboard");
      }
    });
  }, []);
  function handleValidation() {
    let flag = true;
    let error = {};
    if (!fields.title) {
      error["title"] = "Please enter role title";
      flag = false;
    }

    if (!fields.description) {
      error["description"] = "Please enter description";
      flag = false;
    }

    if (!fields.status) {
      error["status"] = "Please select status";
      flag = false;
    }
    setErrors({ ...error });
    return flag;
  }
  const handleSubmit = () => {
    if (handleValidation()) {
      setIsLoader(true);
      configuration
        .postAPI({ url: "role/create", params: fields })
        .then((data) => {
          setIsLoader(false);
          if (data.status === 200) {
            history.push("/role");
            toast.success("Record added successfully");
          } else if (data.status === 404) {
            setIsLoader(false);
            return toast.error(data.error.message);
          } else {
            setIsLoader(false);
            return toast.error("Something went wrong");
          }
        })
        .catch((error) => {
          setIsLoader(false);
          return toast.error(error.message);
        });
    }
  };

  function handleChange(field, e) {
    setFields({ ...fields, [field]: e.target.value });
  }
  return (
    <>
      {isLoader ? <Loader /> : ""}
      <Breadcrumb module={labels.addRole} />
      <AddEditSection
        title="Add Role"
        path="/role"
        fields={fieldArr}
        fieldValue={fields}
        fieldError={errors}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
    </>
  );
}

export default Add;
